import { array } from 'fp-ts';
import { FinancialDocumentType, useRepositoryQuery } from '@mews-commander/data-access';

export const useGetBillCreditNote = (billId: string, documentType: FinancialDocumentType) => {
    const billResult = useRepositoryQuery(
        'bills',
        'getAll',
        {
            billIds: [billId],
        },
        {
            select: ({ bills }) => (bills && array.isNonEmpty(bills) ? bills[0].creditNoteId : null),
            enabled: documentType === FinancialDocumentType.Bill,
        }
    );

    const creditNoteResult = useRepositoryQuery(
        'bills',
        'getAll',
        {
            billIds: billResult.data ? [billResult.data] : null,
        },
        {
            enabled: !!billResult.data,
            select: ({ bills }) => (bills && array.isNonEmpty(bills) ? bills[0] : null),
        }
    );

    return {
        ...creditNoteResult,
        isLoading: creditNoteResult.isInitialLoading || billResult.isInitialLoading,
    };
};
